<template>
  <div class="about">

    <div class="arrow" v-if="this.$parent.filterTags===''">
      <router-link :to="{ name: 'home'}">
        <svg enable-background="new 0 0 256 256" height="256px" version="1.1" viewBox="0 0 256 256" width="256px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"/></svg>
      </router-link>
    </div>
    <div class="arrow" v-if="this.$parent.filterTags!==''">
      <router-link :to="{ name: 'genre', params: { 'genre': this.$parent.filterTags }}">
        <svg enable-background="new 0 0 256 256" height="256px" version="1.1" viewBox="0 0 256 256" width="256px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"/></svg>
      </router-link>
    </div>


    <h1>About</h1>

    Online cinema with public domain movies <br>

    <!-- <br>
    Enhance the front page of <a href="https://archive.org/details/feature_films" target="_blank">Internet Archive's long movies</a> <br> -->

    <br>

  	<h2>Film videos from <a href="https://archive.org/" target="_blank">Internet Archive</a></h2>
    <div>
      <a href="https://archive.org/" target="_blank">
        <img width="92" height="92" src="https://archive.org/services/img/internetarchivebooks">
      </a>
    </div>
    <p>All films displayed here are hosted on archive.org and in the Public Domain.</p>

  	<br>
  	<br>

    <h2>Film datas from <a href="https://www.themoviedb.org/" target="_blank">TMDb</a></h2>
    <div>
      <a href="https://www.themoviedb.org/" target="_blank">
        <!-- <img width="92" height="92" src="https://www.themoviedb.org/assets/static_cache/b32eda2e3812fd459d394791849e7144/images/v4/logos/stacked-blue.svg"> -->
        <img width="92" height="92" src="../assets/tmdb.svg">
      </a>
    </div>
  	<p>All film-related metadata used here, including director, synopses, <br>
  	release dates, poster art and backdrops is supplied by TMDb. <br>
  	We use the TMDb API but our app is not endorsed or certified by TMDb.</p>

    <!-- <h2>Film subtitles from <a href="https://www.opensubtitles.org" target="_blank">OpenSubtitles.org</a></h2>

    <div><a href="https://www.opensubtitles.org" target="_blank"><img width="180" height="50" src="https://static.opensubtitles.org/gfx/logo.gif"></a></div> -->

    <br><br><br>
    stats: 2237 movies<br>
    last update: March 2019
    <br><br><br><br>
    <b>parvu@protonmail.com</b>
        
    
  </div>
</template>

<script>
export default {
  name: 'about',

  mounted: function () {
    var app = document.getElementById("app");
    app.className = 'about';

    
    // console.log("this: ", this);
  },  

  destroyed: function () {    
    var app = document.getElementById("app");
    app.className = '';
  },



  methods: {

    nothing: function () {      


    },

  },

}


</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.about{
  text-align: center;
  padding-top: 5px;
}
.arrow{
  position: fixed;
  top: 100px;
  right: 30px;
  cursor: pointer;

  svg{
    height: 35px;
    width: 35px;
  }
}
a{
  color: #2c3e50;
}

</style>



// WEBPACK FOOTER //
// About.vue?544a0355